function closeRebuyCart() {
  const rebuyCartCloseBtn = document.querySelector('button.rebuy-cart__flyout-close');      
  if (rebuyCartCloseBtn) {
    rebuyCartCloseBtn.click();
  }
}

function ampAddAtcListener() {
  document.addEventListener("click", e => {
      const button = e.target.closest("button.subscription-widget__add-cta");
      if (!button) return;
      //e.stopImmediatePropagation();

      // console.log("Custom AMP Add to Cart clicked:", button);

      setTimeout(() => {
          if (window.AMP_API && typeof window.AMP_API.OPEN_CART === "function") {
              // console.log("Opening AMP cart...");
              window.AMP_API.OPEN_PRE_PURCHASE_UPSELL();
          } else {
              console.error("AMP API not available");
          }
      }, 1000);
  }, true); 
}

window.AMP_CART_UPDATED = (cart, target) => {
  console.log("AMP_CART_UPDATED", cart, target);
  // AMP cart shows the compare_at price of the already-discounted variant price, we need to update it to show the original price of the base product
  // Since Shopify doesn't provide this data in the cart object, we need to get it from a global object that we populate on page load
  // The global object is populated using the snippet `app-state-json.liquid`, which is rendered in `theme.liquid` 

  if (!cart || !cart.items || cart.items.length === 0) {
    return;
  }

  if (!window.VARIANT_JSON) {
    console.warn("VARIANT_JSON not found, cannot update original prices in cart");
    return;
  }
  // Update line item prices to reflect the compare_at price of the base product
  document.querySelectorAll('.amp-cart__cart-line').forEach((lineEl, i) => {
    
    const priceEl = lineEl.querySelector('.amp-cart__cart-line-price');
    const originalPriceEl = priceEl.querySelector('.amp-cart__cart-line-price--original')
    const cartLine = cart.items[i];
    const variant = window.VARIANT_JSON[cartLine.variant_id];
    if (!variant) {
      console.warn("Variant not found for cart line:", cartLine);
      return;
    }

    // update compare at price
    if (cartLine && originalPriceEl) {
      if (variant && variant.original_price && variant.original_price > cartLine.price) {
        const originalPriceValue = (variant.original_price * cartLine.quantity / 100).toFixed(2);
        originalPriceEl.innerHTML = theme.moneyFormat.replace('{{amount}}', originalPriceValue);
      } else {
        // console.log("Hiding original price for variant:", variant, cartLine);
        originalPriceEl.style.display = "none";
      }
    }

    // update subscription discount percent
    const subscriptionEl = lineEl.querySelector('.amp-cart__cart-line-upgrade-to-subscription-container');
    if (cartLine && subscriptionEl && variant && variant.selling_plans && variant.original_price) {
    
      // update the percent for all options in the select dropdown
      subscriptionEl.querySelectorAll('option').forEach(optionEl => {
        const sellingPlanId = optionEl.getAttribute('value');
        if(variant.selling_plans[sellingPlanId]) {
          // calculate the discount percent from the original price - variant.original_price - and the current line item price - cartLine.price
          const discountPercent = Math.round((1 - (cartLine.price / variant.original_price)) * 100);
          // replace "Save X%" in the option text with the calculated discount percent
          optionEl.textContent = optionEl.textContent.replace(/Save \d+%/, `Save ${discountPercent}%`);
        } else {
          optionEl.textContent = optionEl.textContent.replace(/Save \d+%/, '');
        }
      })

      // update the percent for the upgrade button
      subscriptionEl.querySelectorAll('.amp-cart__cart-line-upgrade-to-subscription-button').forEach(buttonEl => {
        // find the lowest price selling plan for this variant
        const lowestPriceSellingPlan = Object.entries(variant.selling_plans).reduce((lowest, [id, plan]) => (
          (plan.price < lowest.price) ? plan : lowest
        ), {price: variant.price});
        
        if (lowestPriceSellingPlan.price) {
          // calculate the discount percent from the original price and update the button text
          const discountPercent = Math.round((1 - (lowestPriceSellingPlan.price / variant.original_price)) * 100);
          // the AMP script fails if we try to set textContent directly, so we need to update the first child node value instead
          if (buttonEl.firstChild && buttonEl.firstChild.nodeType === Node.TEXT_NODE) {
            buttonEl.firstChild.nodeValue = buttonEl.textContent.replace(/Save \d+%/, `Save ${discountPercent}%`);
          }
        }
      })

    }

  })

};


document.addEventListener("DOMContentLoaded", () => {
  ampAddAtcListener();
});